import { TransactionInformation } from 'src/types/redux/transaction.redux.type';
import { StateType } from 'src/types/redux/user.redux.types';
import { StateResultType } from 'src/types/services/state-service.type';

export function getTransactionListForStatus(
  transactionList: TransactionInformation[],
  flowChartNumber: number,
  userState: StateType,
  stateNodeList: StateResultType[],
  checkStatusItem: string | undefined,
) {
  const allToStateNames: { id: string | undefined; stateName: string | undefined }[] = [];
  const usedIds = new Set<string>();

  function pushUnique(item: { id: string | undefined; stateName: string | undefined }) {
    if (!item.id) return;

    if (!usedIds.has(item.id)) {
      usedIds.add(item.id);
      allToStateNames.push(item);
    }
  }

  transactionList
    .filter((t) => t.flowChartType === flowChartNumber)
    .forEach((element) => {
      if (element.userRoleId.some((role) => userState.userRoles.map((r) => r.id).includes(role.id))) {
        if (element.fromStateId === null && element.toStateId === null) {
          const matchedStates = stateNodeList.filter((state) => state.flowChartType === flowChartNumber);

          for (const matchedState of matchedStates) {
            if (matchedState.id === checkStatusItem?.toString()) continue;

            pushUnique({
              id: matchedState.id,
              stateName: matchedState.stateName,
            });
          }
        } else if (element.fromStateId === null && element.toStateId !== checkStatusItem?.toString()) {
          const matchedState = stateNodeList.find((statename) => statename.id === element.toStateId);

          if (matchedState) {
            pushUnique({
              id: matchedState.id,
              stateName: matchedState.stateName,
            });
          }
        } else if (element.toStateId === null && element.fromStateId === checkStatusItem?.toString()) {
          const matchedStates = stateNodeList.filter((state) => state.flowChartType === flowChartNumber);

          for (const matchedState of matchedStates) {
            if (matchedState.id === checkStatusItem?.toString()) continue;

            pushUnique({
              id: matchedState.id,
              stateName: matchedState.stateName,
            });
          }
        } else if (element.fromStateId === checkStatusItem?.toString()) {
          const matchedState = stateNodeList.find((statename) => statename.id === element.toStateId);

          if (matchedState) {
            pushUnique({
              id: matchedState.id,
              stateName: matchedState.stateName,
            });
          }
        }
      }
    });

  return allToStateNames;
}
